import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CapicheLoggerService } from 'capiche-logger';
import { CapicheMaterialModule } from 'capiche-material';
import { ProductViewModel } from '../../models/product-view.model';

@Component({
  selector: 'app-product-price',
  imports: [CommonModule, CapicheMaterialModule],
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.css'],
})
export class ProductPriceComponent {
  logger: CapicheLoggerService = new CapicheLoggerService('product-price.component', false);
  @Input() product!: ProductViewModel;
  @Output() subscribeEmitter = new EventEmitter<ProductViewModel>();
  @Output() onPromoCodeEmitter = new EventEmitter<void>();

  onSubscribe(event: Event) {
    this.logger.log('Subscribe clicked for product:', this.product);
    this.subscribeEmitter.emit(this.product);
    event.stopPropagation();
  }

  onPromoCode() {
    this.logger.log('onPromoCode:', this.product);
    this.onPromoCodeEmitter.emit(); // Emit event when the button is clicked
  }
}
